<template>
  <div class="type-selection">
    <v-menu
      :offset="[0, 36]"
      :disabled="disabled"
      :transition="false"
      content-class="type-selection-content"
    >
      <template #activator="{ props, value }">
        <ToolbarTooltip
          top
          :open-delay="1000"
          :title="title"
        >
          <template #activator="{ props: tooltipOn }">
            <div v-bind="tooltipOn">
              <ToolbarButton
                class="ml-2 mr-2 mt-3 pl-1"
                :class="{ opened: !disabled && value }"
                v-bind="props"
                :icon-name="iconName"
                :disabled="disabled"
              >
                <template
                  v-if="!disabled"
                  #after
                >
                  <v-icon size="small" :icon="value ? '$menu-up' : '$menu-down'" />
                </template>
              </ToolbarButton>
            </div>
          </template>
        </ToolbarTooltip>
      </template>

      <v-list>
        <v-list-item
          v-for="[id, icon, label, itemTitle] in items"
          :key="id"
          @click="$emit('buttonClick', {
            id, state: selected === id, disabled, $event,
          })"
        >
          <v-list-item-title>
            <div
              :class="{ 'selected-type': id === selected }"
              :title="itemTitle"
            >
              <DpplSvg
                class="icon"
                :file-name="`icons/${icon}`"
              />
              <span class="ml-2 format-menu-text">
                {{ label }}
              </span>
            </div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import ToolbarTooltip from '@/components/document/editorToolbar/ToolbarTooltip.vue';
import ToolbarButton from './ToolbarButton.vue';

export default {
  name: 'TypeSelection',
  components: { DpplSvg, ToolbarButton, ToolbarTooltip },
  props: {
    items: { type: Array, default: () => [] },
    selected: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  emits: ['buttonClick'],

  computed: {
    title() {
      return {
        list: 'List',
        heading: 'Heading',
      }[this.selected] || 'Paragraph';
    },
    iconName() {
      return {
        list: 'Icon_List',
        heading: 'Icon_Heading',
      }[this.selected] || 'Icon_Paragraph';
    },
  },
};
</script>

<style lang="less">
.type-selection-content {
  .icon {
    height: 12px;
    fill: @icon-darkest;
  }
  .selected-type {
    color: @text-brand;
    svg {
      fill: @icon-brand;
    }
  }
}
</style>
